import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TKhattabatMatchmakingAuditRow } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetKhattabatMatchmakingAudit = async ({
  startDate,
  endDate
}: {
  startDate: Date;
  endDate: Date;
}): Promise<{
  data: TKhattabatMatchmakingAuditRow[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<
    TKhattabatMatchmakingAuditRow[]
  >(`khattabat/getKhattabatMatchmakingAudit`, {
    startDateObject: getDateAsObject(startDate),
    endDateObject: getDateAsObject(endDate)
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
